import * as _ from 'lodash';
import type { Me } from '@/types/type';

export const useAuthStore = defineStore('authStore', () => {
  const me = ref<Me>();
  const isInitializeCompleted = ref(false);

  const hasRole = (role: string) : boolean => {
    if (me.value == undefined) {
      return false;
    }
    return _.get(me, ['value', 'roles'], '').indexOf(role) > -1;
  }

  return { isInitializeCompleted, me, hasRole }  
})
